export const prompt = [
  {
    id: "purpose",
    type: "dropdown",
    choices: ["Feed the prompt to AI chatbots"],
  },
  {
    id: "Situation",
    type: "textarea",
  },
  {
    id: "My_Prompt",
    type: "textarea",
  },
];
